import React, { useState } from "react";
import { Formik } from "formik";
import { injectIntl } from "react-intl";
import { isEmpty } from "lodash-es";
import { Column, Container, Row } from "../Grid";
import ActionBar from "../ActionBar/ActionBar";
import Heading from "../Heading";
import Loader from "../Loader";
import PermissionsEdit from "../Permissions/PermissionsEdit";
import PermissionType from "../../constants/PermissionType";
import {
  Form,
  CancelButton,
  SubmitButton,
  TextInput,
  ButtonGroup,
} from "../Form";
import { intlShape } from "../../shapes";
import { withApi, apiShape, notifierShape, withNotifier } from "../../context";
import withAccessRights from "../../wrappers/withAccessRights";
import BackButton from "../BackButton";

type Props = {
  intl: intlShape;
  match?: {
    params?: {
      id?: string;
    };
  };
  api: apiShape;
  notifier: notifierShape;
};

export function SubscriptionEdit({ intl, match, api, notifier }: Props) {
  const [subscription, setSubscription] = useState();
  React.useEffect(() => {
    const loadSubscription = async () => {
      try {
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        const response = await api.get(`/subscriptions/${match.params.id}`, {
          include: "customer",
        });
        setSubscription(response);
      } catch (error) {
        notifier.showError(api.translateError(error));
      }
    };

    loadSubscription();
  }, [match]);

  const validateForm = (values: $TSFixMe) => {
    const errors = {};

    if (isEmpty(values.label)) {
      (errors as $TSFixMe).label = intl.formatMessage({
        id: "validation.label.mandatory",
      });
    }

    if (isEmpty(values.customer_number)) {
      (errors as $TSFixMe).customer_number = intl.formatMessage({
        id: "validation.label.mandatory",
      });
    }
    return errors;
  };

  const renderForm = (formProps: $TSFixMe) => {
    const { isSubmitting } = formProps;
    return (
      <Form {...formProps}>
        <TextInput
          {...formProps}
          id="label"
          name="label"
          label={intl.formatMessage({ id: "label.name" })}
          required
        />
        <TextInput
          {...formProps}
          id="customer_number"
          name="customer_number"
          label={intl.formatMessage({ id: "label.account_number" })}
          required
        />
        <ButtonGroup>
          <SubmitButton
            id="subscription-form-submit-button"
            fetching={isSubmitting}
            disabled={!formProps.dirty}
          />
          <CancelButton
            id="subscription-form-cancel-button"
            fetching={isSubmitting}
          />
        </ButtonGroup>
      </Form>
    );
  };

  const handleOnSubmit = async (values: $TSFixMe, actions: $TSFixMe) => {
    try {
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      await api.patch(`/subscriptions/${subscription.id}`, {
        reseller_label: values.label,
      });
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      await api.patch(`/customers/${subscription.customer.id}`, {
        number: values.customer_number,
      });
      notifier.showSuccess(
        intl.formatMessage({ id: "subscription_edit.success_notification" }),
      );
      actions.resetForm({ values });
    } catch (error) {
      notifier.showError(api.translateError(error));
    } finally {
      actions.setSubmitting(false);
    }
  };

  return (
    <Loader loading={!subscription}>
      <Container>
        <Row>
          <Column>
            <BackButton />
          </Column>
        </Row>
        <Row>
          <Column>
            <ActionBar>
              <Heading
                title={intl.formatMessage({ id: "subscription_edit.header" })}
              />
            </ActionBar>
          </Column>
        </Row>
        {subscription &&
          !isEmpty(
            (subscription as $TSFixMe).reseller_label ||
              (subscription as $TSFixMe).customer?.number,
          ) && (
            <Row>
              <Column>
                <Formik
                  id="subscription-form"
                  initialValues={{
                    label: (subscription as $TSFixMe).reseller_label,
                    customer_number: (subscription as $TSFixMe).customer.number,
                  }}
                  onSubmit={handleOnSubmit}
                  validate={validateForm}
                >
                  {renderForm}
                </Formik>
              </Column>
            </Row>
          )}
        <Row>
          <Column>
            <PermissionsEdit
              // @ts-expect-error TS(2322) FIXME: Type '{ id: string; permitableType: string; permit... Remove this comment to see the full error message
              id="subscription-edit-permissions"
              permitableType="Subscription"
              // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
              permitableId={Number(match.params.id)}
              targetOnDeleteOwnReadPermission="/subscription"
              allowedPermissions={[
                PermissionType.READ,
                PermissionType.UPDATE,
                PermissionType.PERMIT,
              ]}
            />
          </Column>
        </Row>
      </Container>
    </Loader>
  );
}

export default injectIntl(
  // @ts-expect-error TS(2345) FIXME: Argument of type '{ (props: Readonly<Omit<WithAcce... Remove this comment to see the full error message
  withNotifier(withApi(withAccessRights(SubscriptionEdit, "Subscription"))),
);
